import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const requestReset = async (e) => {
    e.preventDefault();
    setErr(""); setMsg("");
    try {
      await api.post("/auth/forgot-password", { email });
      setMsg("If that email exists, a reset link has been sent. (In this demo it is printed to the server log.)");
    } catch (e2) { setErr(formatApiError(e2.response?.data?.detail)); }
  };

  const doReset = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated.");
      navigate("/login");
    } catch (e2) { setErr(formatApiError(e2.response?.data?.detail)); }
  };

  return (
    <div className="min-h-screen bg-donkey-bg grain flex flex-col">
      <div className="p-6"><Logo /></div>
      <div className="flex-1 flex items-center justify-center px-5 pb-16">
        <div className="w-full max-w-md card-donkey rounded-2xl p-8">
          <h1 className="font-heading font-bold text-2xl text-donkey-warm">
            {token ? "Set a new password" : "Reset your password"}
          </h1>
          {token ? (
            <form onSubmit={doReset} className="mt-7 space-y-5">
              <div>
                <Label className="text-donkey-warm/90">New password</Label>
                <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  className="mt-1.5 bg-donkey-bg border-white/15 text-donkey-warm" data-testid="reset-password" />
              </div>
              {err && <p className="text-sm text-donkey-red">{err}</p>}
              <Button type="submit" className="w-full bg-donkey-orange text-donkey-black font-semibold h-11" data-testid="reset-submit">
                Update password
              </Button>
            </form>
          ) : (
            <form onSubmit={requestReset} className="mt-7 space-y-5">
              <div>
                <Label className="text-donkey-warm/90">Email</Label>
                <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="mt-1.5 bg-donkey-bg border-white/15 text-donkey-warm" data-testid="forgot-email" />
              </div>
              {msg && <p className="text-sm text-donkey-green">{msg}</p>}
              {err && <p className="text-sm text-donkey-red">{err}</p>}
              <Button type="submit" className="w-full bg-donkey-orange text-donkey-black font-semibold h-11" data-testid="forgot-submit">
                Send reset link
              </Button>
            </form>
          )}
          <p className="text-sm text-donkey-grey mt-6 text-center">
            <Link to="/login" className="text-donkey-orange hover:underline">Back to log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
